// extracted by mini-css-extract-plugin
export default {"container":"jq-z","heading":"kq-z","text":"lq-z","info":"mq-z","link":"nq-z","fullMaxWidth":"oq-z"};